App.filter('nowYearAndMonth', function() {
    return function() {
        var date = new Date();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();

        var now = {
            month: month,
            year: year
        }

        return now;
    }
});